export const KK_TRANSLATION = {
  lang: 'kk',
  messages: {
  }
};
